export { default } from './spinner';